export const setCookie = (cookieName, cookieValue, expirationDays) => {
  const d = new Date();
  d.setTime(d.getTime() + expirationDays * 24 * 60 * 60 * 1000);
  const expires = 'expires=' + d.toUTCString();
  document.cookie = cookieName + '=' + cookieValue + ';' + expires + ';path=/';
};

const removeEmptyElement = (className) => {
  const element = document.querySelector(`.${className}`);
  if (element && element.innerHTML.trim() === '') {
    element.remove();
  }
};
removeEmptyElement('footerblock__middle-firstsection');
removeEmptyElement('footerblock__middle-secondsection');
removeEmptyElement('footerblock__middle-thirdsection');
const mainblock = document.querySelector('.footerblock__middle');
if (mainblock && mainblock.innerHTML.trim() === '') {
  mainblock.remove();
}
